var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "embed-block" }, [
    _vm.renderedTag
      ? _c("div", {
          staticClass: "embed-block__host",
          domProps: { innerHTML: _vm._s(_vm.renderedTag) },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }